import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../app/core/services/auth.service';
import { HomeService } from '../../../../../app/core/services/home.service';
import { RoleService } from '../../../../../app/core/services/role.service';
import { UserService } from '../../../../../app/core/services/user.service';
import { AppActionCheck } from '../../../../../app/core/utils/app-action-check';
import { AppErrorShow } from '../../../../../app/core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../app/core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../app/core/utils/global-name';
import { LocalStorageService } from '../../../../../app/core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { CountryService } from '../../../../core/services/country.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    NgbModule,
    NgxPaginationModule,
    LoadingComponent,
    SampleSearchPipe
    
  ]
})
export class UserComponent implements OnInit {


  buttonsPermission :any|undefined;
  renters:any[] =[]
  roles:any[] =[]
  countries:any[] =[]
  homes:any[] =[]
  data:any[] =[]
  owners:any[] =[]
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  associate=null

    search_text=""
role:any
  user:any
pg={
    pageSize:10,
    p:0,
    total:0
  }
  tag="Utilisateurs"



  constructor(
    private authService:AuthService,
    private countryService:CountryService,
    private userService:UserService,
    private roleService:RoleService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.user=this.lsService.get(GlobalName.userName)
    this.role=this.user.roles[0].name
    this.init()
   this.getActions()
  }

  init(){
    this.getAll()
    this.getRoles()
    this.getCountries()
  }


  getCountries(){
    this.countryService.getAll().subscribe((res:any)=>{
      this.countries=res.data
    },
    (err:any)=>{

    })
  }
  getRoles(){
    this.roleService.getAll().subscribe((res:any)=>{
      this.roles=res.data
    },
    (err:any)=>{

    })
  }

  getAll(){
    this.userService.getAll().subscribe((res:any)=>{
      this.data=res.data 
this.pg.pageSize=10
 this.pg.p=0
 this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
      AppErrorShow.showError("Gestion des utilisateurs",err)

    })
  }


  store(value:any){
    this.loading=true
    this.userService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des utilisateurs",err)
    })
  }
  update(value:any){
    this.loading=true

    this.userService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des utilisateurs",err)
    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.userService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des utilisateurs",err)
    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }


  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.userService.setStatus(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
        AppErrorShow.showError("Gestion des utilisateurs",err)
      })
  }

  resetPassword(value:any){
    this.loading=true
    value["id"]=this.selected_data.id
    this.authService.resetPassword(value).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success('Réinitialisation de mot de passe', 'Mon compte');
      this.modalService.dismissAll()
    },
    (err:any)=>{
      this.loading=false
      this.toastrService.error('Réinitialisation de mot de passe', 'Mon compte');

    });
  }
  getPage(event:any){
    this.pg.p=event
  }

  
  getActions(){
    this.buttonsPermission = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:AppActionCheck.check(this.tag,'Mettre un statut'),
      print:AppActionCheck.check(this.tag,'Imprimer/Télécharger'),
      transUp:AppActionCheck.check(this.tag,'Transmettre'),
      transDown:AppActionCheck.check(this.tag,'Affecter'),
      sign:AppActionCheck.check(this.tag,'Signer'),
      viewer:AppActionCheck.check(this.tag,'Visualiser Fichier'),
      return:AppActionCheck.check(this.tag,'Retouner pour correction')
    };
  }
}
